import React from "react"
import AdminPanelDom from "../domains/adminPanel/adminPanelDom"
import FintechConnection from "./FintechForm"
class AdminPanelSubServizzi extends React.Component {
  render() {
    return (
      <AdminPanelDom
        component={({ MessaggiComponent }) => <FintechConnection />}
        {...this.props}
      />
    )
  }
}
export default AdminPanelSubServizzi
